module.exports = __webpack_public_path__ + "static/media/promo5.97b54ea7.jpg";